import React from 'react';
import {cancel} from '../../../../app-components/action/CancelAction';
import {save} from '../../../../app-components/action/SaveAction';
import MedicalAssistantForm from './MedicalAssistantForm';
import {EditClinicAdmin} from '../../../../Queries';
import CustomHeaderLabel from '../../../../app-components/CustomHeaderLabel';

// const header = {
//   title: 'Edit Clinic Admin',
//   actions: [cancel(), save({label: 'Save'})],
// };
const uri=({navigation})=>{
  return {
    query: {
      id: 'userLists',
      relationValue: {
        model: 'User',
        _id: navigation.state.params.item._id,
        relation: '_id',
      },
      limit: 1,
    },
    model: 'User',
  }
}
const header = {
  hideBackIcon: true,
  title: ({navigation}) => {
    const {state: {params: {item} = {}} = {}} = navigation;
    return (
      <CustomHeaderLabel
        seperator={true}
        preLabel={'Edit User Detail'}
        postLabel={item?.name}
      />
    );
  },
  actions: [cancel(), save()],
};

export default MedicalAssistantForm({header, uri});
